import CloseIcon from '@mui/icons-material/Close';
import React, { useContext } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, Tooltip } from '@mui/material';
import Loading from '../../../components/Common/Loaders/FullWidthLoader/Loading';
import { LanguageContext } from '../../../libs/Context';

const NoneAccessPopup = ({ handleClose, handleSave, loading }) =>
{
	const { language } = useContext(LanguageContext);

	return (
		<Dialog open fullWidth>
			{loading && <Loading />}
			<DialogTitle>
				<div className='flexRow brdrBSM alignCntr pdngSM'>
					<div className='flexMinWidthRow'>{language.info}</div>
					<button
						tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleClose(); }}

						className='flexAutoRow pointer' onClick={handleClose}
					>
						<Tooltip title='close'>
							<CloseIcon />
						</Tooltip>
					</button>
				</div>
			</DialogTitle>
			<DialogContent>
				<div className='flexRow alignCntr justifyCntr'>
					<span className='textCntr'>{language.switchingEditView}</span>
				</div>
			</DialogContent>
			<div className='flexRow alignCntr justifyEnd pdngVMD'>
				<div className='flexInline'>
					<Button variant='outlined' disableElevation disableRipple
						tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleClose(); }}

						onClick={handleClose}
					>
						{language.close}
					</Button>
				</div>
				<div className='flexInline pdngHMD'>
					<Button variant='contained' className='whiteTxt'
						tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleSave(); }}

						disableElevation disableRipple onClick={handleSave}
					>
						{language.done}
					</Button>
				</div>
			</div>
		</Dialog>
	);
};

export default NoneAccessPopup;